import { z } from 'zod';

/** The platform's password rule (same as the server): 8-72 characters with both letters and numbers. */
export const passwordProblem = (password: string): string | null => {
  if (password.length < 8) return 'Use at least 8 characters.';
  if (new TextEncoder().encode(password).length > 72) return 'Use at most 72 characters.';
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) return 'Use both letters and numbers.';
  return null;
};

export const PASSWORD_HINT = 'At least 8 characters, with letters and numbers.';

/** A password being set. */
export const strongPassword = z.string().superRefine((value, ctx) => {
  const problem = passwordProblem(value);
  if (problem) ctx.addIssue({ code: z.ZodIssueCode.custom, message: problem });
});

/** A password field on an edit form: blank keeps the current password. */
export const optionalStrongPassword = z.string().optional().or(z.literal('')).superRefine((value, ctx) => {
  const problem = value ? passwordProblem(value) : null;
  if (problem) ctx.addIssue({ code: z.ZodIssueCode.custom, message: problem });
});
